'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactstrap = require('reactstrap');

var _AbstractField2 = require('./AbstractField');

var _AbstractField3 = _interopRequireDefault(_AbstractField2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// TODO NOPEPARTS -- Podezřelá komponenta --
/**
 * Custom select field
 */
var CustomSelectField = function (_AbstractField) {
    (0, _inherits3.default)(CustomSelectField, _AbstractField);

    function CustomSelectField() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, CustomSelectField);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CustomSelectField.__proto__ || (0, _getPrototypeOf2.default)(CustomSelectField)).call.apply(_ref, [this].concat(args))), _this), _this.handleItemSelect = function (item, e) {
            var _this$props = _this.props,
                onChange = _this$props.onChange,
                getItemValue = _this$props.getItemValue;

            onChange(getItemValue(item));
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(CustomSelectField, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                addonsBefore = _props.addonsBefore,
                addonsAfter = _props.addonsAfter,
                onChange = _props.onChange,
                onBlur = _props.onBlur,
                onFocus = _props.onFocus,
                value = _props.value,
                renderItem = _props.renderItem,
                getItemValue = _props.getItemValue,
                items = _props.items,
                key = _props.key,
                disabled = _props.disabled,
                props = (0, _objectWithoutProperties3.default)(_props, ['addonsBefore', 'addonsAfter', 'onChange', 'onBlur', 'onFocus', 'value', 'renderItem', 'getItemValue', 'items', 'key', 'disabled']);


            var itemsEl = items.map(function (item, index) {
                var onClick = disabled ? null : _this2.handleItemSelect.bind(_this2, item);
                return _react2.default.createElement(
                    'div',
                    { onClick: onClick, key: 'CustomSelectField-Item-' + index },
                    renderItem(item, getItemValue(item) === value)
                );
            });

            var field = _react2.default.createElement(
                'div',
                (0, _extends3.default)({}, props, {
                    key: key,
                    disabled: disabled
                }),
                itemsEl
            );

            return this.renderFieldWithAddons(field, addonsBefore, addonsAfter);
        }
    }]);
    return CustomSelectField;
}(_AbstractField3.default);

CustomSelectField.PropTypes = (0, _extends3.default)({}, _AbstractField3.default.propTypes, {
    items: _react2.default.PropTypes.array.isRequired,
    renderItem: _react2.default.PropTypes.func,
    getItemValue: _react2.default.PropTypes.func
});
CustomSelectField.defaultProps = {
    renderItem: function renderItem(item, active) {
        return _react2.default.createElement(
            'div',
            { className: active ? "active" : "" },
            active ? "#" : "",
            item.name
        );
    },
    getItemValue: function getItemValue(item) {
        return item ? item.id : null;
    }
};
exports.default = CustomSelectField;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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